import * as React from 'react';
import { memo } from 'react';
import { Space } from 'antd';
import { Section } from '../knowledge-base.type';
import Button from '/react4xp/mixins/ui/button/button';

interface SectionSelectorProps {
    sections: Section[];
    activeSection: Section;
    selectSection: React.Dispatch<React.SetStateAction<Section>>;
}

const SectionSelector = memo(({ sections, activeSection, selectSection }: SectionSelectorProps) => {
    return (
        <Space wrap>
            {sections.map((section) => (
                <Button
                    key={section.id}
                    onClick={() => selectSection(section)}
                    color={section === activeSection ? 'blue' : ''}
                    className="section-button"
                    style={{ minWidth: '300px' }}
                >
                    <Space align="center">{section.title}</Space>
                </Button>
            ))}
        </Space>
    );
});

export default SectionSelector;
